module.exports = __webpack_public_path__ + "img/menu_approval.71dede31.svg";